var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeTriangleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.617007 1.58414C0.257901 0.867344 0.766326 0 1.58414 0H9.41569C10.2335 0 10.7419 0.867344 10.3828 1.58414L6.46706 9.40025C6.06638 10.1999 4.93344 10.1999 4.53275 9.40025L0.617007 1.58414Z",
    fill: "#FF7926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeTriangleDown);
export default __webpack_public_path__ + "static/media/orange-triangle-down.09dd6b003c70132165a13fc6e5e80b2d.svg";
export { ForwardRef as ReactComponent };